import { Box, Typography } from "@mui/material";
import React from "react";
import { Reveal } from "src/theme/animation";
import HeroSection from "src/theme/HeroSection";

const OriginStory: React.FC = () => {
    return (
        <Box sx={{ mb: 8 }}>
            <HeroSection
                imageUrl="/images/SeanValentine-HGP.jpg"
                minHeight="70vh"
                animateHero
            >
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 1,
                        px: { xs: 3, sm: 4, md: 6 },
                        py: 4,
                        maxWidth: 560
                    }}
                >
                    <Reveal variant="fadeUp" trigger="mount">
                        <Typography
                            variant="h3"
                            component="h1"
                            sx={{
                                mb: 3,
                                fontWeight: "bold",
                                color: "white"
                            }}
                        >
                            About Strong Mind Strong Performance
                        </Typography>
                    </Reveal>

                    <Reveal variant="fadeUp" trigger="mount">
                        <Typography
                            component="p"
                            sx={{
                                lineHeight: 1.6,
                                mb: 2,
                                color: "rgba(255,255,255,0.95)"
                            }}
                        >
                            Strong Mind Strong Performance™ exists because skill was never the whole story. Built on over 10 years of youth and human development experience, SMSP helps parents, coaches, mentors, and leaders develop the self-belief, emotional regulation, and resilience that sit underneath real performance -- on the field, in the classroom, and at work.
                        </Typography>
                    </Reveal>

                    <Reveal variant="fadeUp" trigger="mount">
                        <Typography
                            component="p"
                            sx={{
                                lineHeight: 1.6,
                                color: "rgba(255,255,255,0.95)"
                            }}
                        >
                            Research suggests that up to 90% of sports performance is driven by psychological factors—yet most development programs focus almost entirely on the physical.
                        </Typography>
                    </Reveal>
                </Box>
            </HeroSection>
        </Box>
    );
};

export default OriginStory;
